const levels = new Map();

levels.set(1, { duration: 10, spawnDelay: 100, foregroundSpeed: 3 });
levels.set(2, { duration: 25, spawnDelay: 50, foregroundSpeed: 3.2 });
levels.set(3, { duration: 50, spawnDelay: 25, foregroundSpeed: 3.4 });
levels.set(4, { duration: 100, spawnDelay: 10, foregroundSpeed: 3.6 });
levels.set(5, { duration: 150, spawnDelay: 5, foregroundSpeed: 3.8 });
levels.set(6, { duration: 200, spawnDelay: 5, foregroundSpeed: 4 });
levels.set(7, { duration: 250, spawnDelay: 5, foregroundSpeed: 4.2 });
levels.set(8, { duration: 300, spawnDelay: 5, foregroundSpeed: 4.4 });
levels.set(9, { duration: 350, spawnDelay: 5, foregroundSpeed: 4.6 });

export default levels;
